module.exports = __webpack_public_path__ + "media/post-listing-block-4-image.d7073e6f.jpg";